"use strict";
/**
 * An enum used to track the type of a proxied array, and determine the proxying strategy.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ArrayType;
(function (ArrayType) {
    /**
     * An array of arrays.
     */
    ArrayType[ArrayType["ARRAY"] = 0] = "ARRAY";
    /**
     * An array of dynamic objects.
     */
    ArrayType[ArrayType["DYNAMIC_OBJECT"] = 1] = "DYNAMIC_OBJECT";
    /**
     * An array of primative values.
     */
    ArrayType[ArrayType["PRIMATIVE"] = 2] = "PRIMATIVE";
    /**
     * An array of static objects.
     */
    ArrayType[ArrayType["STATIC_OBJECT"] = 3] = "STATIC_OBJECT";
    /**
     * An array of unknown type (because it has no contents)
     */
    ArrayType[ArrayType["UNKNOWN"] = 4] = "UNKNOWN";
})(ArrayType || (ArrayType = {}));
exports.default = ArrayType;
//# sourceMappingURL=ArrayType.js.map